
import * as angular from "angular";
import { AccountController } from "./account.controller";
import { PasswordEditorComponent } from "./passwordEditor/passwordEditor.component";


angular
    .module("app.components.account", ["ngMaterial", "ngMessages"])
    .controller("accountController", AccountController)
    .component("passwordEditor", new PasswordEditorComponent())
